import {
  SEARCH_INPUT_KEYWORD,
  SEARCH_STATUS_IDLE,
  SEARCH_STATUS_PROCESSING,
  SEARCH_STATUS_SUCCESS,
  SEARCH_STATUS_FAILED,
} from '../constants/search'
import {
  FOCUS_INPUT,
  UPDATE_INPUT,
  DELETE_INPUT,
  ERROR_INPUT,
  SET_STATUS,
  FOCUS_KEYBOARD,
  START_OVER,
  LOAD_SUGGESTION,
  SEARCH_REQUEST,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  SEARCH_TRENDING_REQUEST,
  SEARCH_TRENDING_SUCCESS,
  SEARCH_TRENDING_FAILURE,
  SEARCH_RECENT_REQUEST,
  SEARCH_RECENT_SUCCESS,
  SEARCH_RECENT_FAILURE,
  SEARCH_SUGGESTED_CLEAR,
  SEARCH_SUGGESTED_REQUEST,
  SEARCH_SUGGESTED_SUCCESS,
  SEARCH_SUGGESTED_FAILURE,
} from '../actions/search'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'

const INITIAL_STATE = {
  status: SEARCH_STATUS_IDLE,
  focusedInput: SEARCH_INPUT_KEYWORD,
  keyboardFocused: true,
  errors: {},
  statusReason: '',
  channels: [],
  videos: [],
  trending: [],
  trendingReady: false,
  trendingLoading: false,
  recent: [],
  recentReady: false,
  recentLoading: false,
  suggested: [],
  suggestedReady: false,
  suggestedLoading: false,
}

INITIAL_STATE[SEARCH_INPUT_KEYWORD] = ''
INITIAL_STATE.errors[SEARCH_INPUT_KEYWORD] = ''

const checkoutReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FOCUS_INPUT:
      return {
        ...state,
        focusedInput: action.payload.focusedInput
      }
    case UPDATE_INPUT:
      return {
        ...state,
        [state.focusedInput]: action.payload.newKey,
        errors: {
          ...state.errors,
          [state.focusedInput]: '',
        },
        status: SEARCH_STATUS_IDLE,
      }
    case DELETE_INPUT:
      return {
        ...state,
        [state.focusedInput]: state[state.focusedInput].substr(
          0,
          state[state.focusedInput].length - 1
        ),
        errors: {
          ...state.errors,
          [state.focusedInput]: '',
        },
        status: SEARCH_STATUS_IDLE,
      }
    case ERROR_INPUT:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.input]: action.payload.error,
        },
      }
    case SET_STATUS:
      return {
        ...state,
        status: action.payload.status,
      }
    case FOCUS_KEYBOARD:
      return {
        ...state,
        keyboardFocused: action.payload.focus,
      }
    case SEARCH_REQUEST:
      return {
        ...state,
        status: SEARCH_STATUS_PROCESSING,
        recent: [action.payload, ...state.recent],
      }
    case SEARCH_SUCCESS:
      return {
        ...state,
        status: SEARCH_STATUS_SUCCESS,
        channels: action.payload.channels,
        videos: action.payload.videos,
      }
    case SEARCH_FAILURE:
      return {
        ...state,
        status: SEARCH_STATUS_FAILED,
        statusReason: action.payload.message,
      }

    case START_OVER:
      return {
        ...state,
        [SEARCH_INPUT_KEYWORD]: '',
        status: SEARCH_STATUS_IDLE,
        errors: {
          [SEARCH_INPUT_KEYWORD]: '',
        },
        statusReason: '',
        channels: [],
        videos: [],
        suggested: [],
        suggestedReady: false,
        suggestedLoading: false,
      }

    case LOAD_SUGGESTION:
      return {
        ...state,
        [SEARCH_INPUT_KEYWORD]: action.payload,
        status: SEARCH_STATUS_IDLE,
        errors: {
          [SEARCH_INPUT_KEYWORD]: '',
        },
        statusReason: '',
        channels: [],
        videos: [],
        suggested: [],
        suggestedReady: false,
        suggestedLoading: false,
      }

    case SEARCH_TRENDING_REQUEST:
      return {
        ...state,
        trending: [],
        trendingReady: false,
        trendingLoading: true,
      }
    case SEARCH_TRENDING_SUCCESS:
      return {
        ...state,
        trending: action.payload.results,
        trendingReady: true,
        trendingLoading: false,
      }
    case SEARCH_TRENDING_FAILURE:
      return {
        ...state,
        trending: [],
        trendingReady: true,
        trendingLoading: false,
      }

    case SEARCH_RECENT_REQUEST:
      return {
        ...state,
        recent: [],
        recentReady: false,
        recentLoading: true,
      }
    case SEARCH_RECENT_SUCCESS:
      return {
        ...state,
        recent: action.payload.results,
        recentReady: true,
        recentLoading: false,
      }
    case SEARCH_RECENT_FAILURE:
      return {
        ...state,
        recent: [],
        recentReady: true,
        recentLoading: false,
      }

    case SEARCH_SUGGESTED_CLEAR:
      return {
        ...state,
        suggested: [],
        suggestedReady: false,
        suggestedLoading: false,
      }

    case SEARCH_SUGGESTED_REQUEST:
      return {
        ...state,
        suggestedLoading: true,
      }
    case SEARCH_SUGGESTED_SUCCESS:
      if (!state.suggestedLoading || state[SEARCH_INPUT_KEYWORD] === '') {
        return state
      } else {
        return {
          ...state,
          suggested: action.payload.results,
          suggestedReady: true,
          suggestedLoading: false,
        }
      }
    case SEARCH_SUGGESTED_FAILURE:
      return {
        ...state,
        suggested: [],
        suggestedReady: true,
        suggestedLoading: false,
      }

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
      return {
        ...INITIAL_STATE,
      }

    default:
      return state
  }
}

export default checkoutReducer
